<img src="../../../../assets/dist/img/HEATMAP.png" width="100%" (click)="onHeatImgClick()">